import { useTranslation } from 'react-i18next'

import Icon from './Icon'

import { Banner } from '../../types/contexts/AppContext'

interface BannerHostProps {
  banner: Banner | null
  onClose: () => void
}

const BannerHost = ({ banner, onClose }: BannerHostProps) => {
  const { t } = useTranslation('common')

  if (!banner) return null

  const cls = `ph-banner ${banner.kind}`
  const iconName =
    banner.kind === 'err' ? 'warn' : banner.kind === 'ok' ? 'check' : 'info'

  return (
    <div className={cls} role="status">
      <span className="ico">
        <Icon name={iconName} size={18} />
      </span>
      <span>{banner.msg}</span>
      <button onClick={onClose} aria-label={t('banner.dismiss')}>
        ×
      </button>
    </div>
  )
}

export default BannerHost
